import React from 'react';
import { ConfigProvider, Layout, Spin, Alert } from 'antd';
import { antdTheme } from './theme';
import { useAmbassadors } from './hooks/useAmbassadors';
import DashboardLayout from './components/layout/DashboardLayout';

const { Content } = Layout;

function App() {
  const { ambassadors, loading, error, metadata } = useAmbassadors();

  if (loading) {
    return (
      <ConfigProvider theme={antdTheme}>
        <Layout style={{ minHeight: '100vh' }}>
          <Content 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              flexDirection: 'column',
              gap: '16px'
            }}
          >
            <Spin size="large" />
            <div style={{ color: '#005d83', fontSize: '18px', fontWeight: 500 }}>
              Loading Artelia TRACE Ambassador Network...
            </div>
          </Content>
        </Layout>
      </ConfigProvider>
    );
  }

  if (error) {
    return (
      <ConfigProvider theme={antdTheme}>
        <Layout style={{ minHeight: '100vh' }}>
          <Content 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              padding: '24px'
            }}
          >
            <Alert
              message="Failed to Load Ambassador Data"
              description={error}
              type="error"
              showIcon
              style={{ maxWidth: '500px' }}
            />
          </Content>
        </Layout>
      </ConfigProvider>
    );
  }

  return (
    <ConfigProvider theme={antdTheme}>
      <DashboardLayout 
        ambassadors={ambassadors}
        metadata={metadata}
      />
    </ConfigProvider>
  );
}

export default App;